<template>
  <div>
    <app-layout>
      <template v-slot:header>
        <Header
          :title="$t('u_pass_purchases_title')"
          :isNewButton="false"
          @filter-div-status="datatable.filterStatus = $event"
        />
      </template>
      <template v-slot:header-mobile>
        <HeaderMobile
          :title="$t('u_pass_purchases_title')"
          :isNewButton="false"
          @filter-div-status="datatable.filterStatus = $event"
        />
      </template>

      <div class="container-fluid py-3">
        <datatable-filter v-show="datatable.filterStatus" :export-excel="true" @exportExcel="excelExport" @filter="filter" @filterClear="filterClear">
          <b-row>
            <b-col md="4" sm="6">
              <b-form-group :label="$t('student_number')">
                <b-form-input v-model="datatable.queryParams.filter.student_number" />
              </b-form-group>
            </b-col>
              <b-col md="4" sm="6">
                  <b-form-group :label="$t('student_name')">
                      <b-form-input v-model="datatable.queryParams.filter.student_name" />
                  </b-form-group>
              </b-col>
              <b-col   md="4" sm="6">
                  <b-form-group :label="$t('program')">
                      <program-selectbox v-model="datatable.queryParams.filter.program_code"  :is-active="true">
                      </program-selectbox>
                  </b-form-group>
              </b-col>
              <b-col   md="4" sm="6">
                  <b-form-group :label="$t('registration_type')">
                     <ParameterSelectbox
                         v-model="datatable.queryParams.filter.registration_type"
                         code="registration_types"
                       />
                  </b-form-group>
              </b-col>
              <b-col md="4" sm="6">
              <b-form-group :label="$t('status')">
                  <multi-selectbox
                      :options="statusOptions"
                      :multiple="true"
                      v-model="datatable.queryParams.filter.status"
                  />
              </b-form-group>
            </b-col>
          </b-row>
        </datatable-filter>

        <datatable
          :isLoading.sync="datatable.isLoading"
          :columns="datatable.columns"
          :rows="datatable.rows"
          :total="datatable.total"
          :queryParams="datatable.queryParams"
          :lineNumbers="false"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-per-page-change="onPerPageChange"
          v-show="datatable.showTable"
        />
      </div>
    </app-layout>
  </div>
</template>

<script>
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import UPassService from "@/services/UPassService";
import moment from "moment";
import qs from "qs";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import excel from "@/modules/prepStudents/pages/Excel.vue";

export default {
  name: "AdminUPassPurchases",
    computed: {
        excel() {
            return excel
        }
    },
  components: {
      MultiSelectbox,
    AppLayout,
    Header,
    HeaderMobile,
    DatatableFilter,
    Datatable
  },
  metaInfo() {
    return {
      title: this.$t("u_pass_purchases_title")
    };
  },
  data() {
    return {
        statusOptions: [
            { value: "pending_payment", text: this.$t("pending") },
            { value: "paid", text: this.$t("paid") },
        ],
      datatable: {
        isLoading: false,
        filterStatus: true,
        showTable: true,
        columns: [
          {
            label: this.$t("id"),
            field: "id",
            hidden: true,
          },
          {
            label: this.$t("student_number"),
            field: "student_number",
            sortable: false
          },
          {
            label: this.$t("name"),
            field: "name",
            sortable: false,

          },
            {
                label: this.$t("surname"),
                field: "surname",
                sortable: false,

            },

            {
                label: this.$t("program"),
                field: "program",
                sortable: false,
            },
            {
                label: this.$t("registration_type"),
                field: "registration_type_name",
                sortable: false,
            },

          {
            label: this.$t("type"),
            field: "student_type",
            sortable: true,
            html: true,
            formatFn: (value) => {
              const type = (value || 'BAU').toUpperCase();
              const badgeClass = value === 'mentora' ? 'badge badge-warning' : 'badge badge-primary';
              return `<span class="${badgeClass}">${type}</span>`;
            }
          },
          {
            label: this.$t("semester"),
            field: "period.academic_year",
            sortable: true
          },
          {
            label: this.$t("amount"),
            field: "amount",
            sortable: true,
            html: true,
            formatFn: (value, row) => {
              const price = value || row.price || 135;
              return  this.formatToCurrency(price);
            }
          },
            {
                label: this.$t("status"),
                field: "status",
                sortable: true,
                html: true,
                formatFn: (value) => {
                    const statusStr = value === 'pending_payment' ? 'pending' : 'paid'
                    let badgeClass = 'badge badge-success';
                    if (statusStr === 'pending') badgeClass = 'badge badge-warning';
                    if (statusStr === 'paid') badgeClass = 'badge badge-success';
                    return `<span class="${badgeClass}">${statusStr.toUpperCase()}</span>`;
                },
            },
            {
                label: this.$t("Purchase Date"),
                field: "purchased_at",
                sortable: true,
            },
            {
                label: this.$t("Created at"),
                field: "created_at",
                sortable: true,
            },
        ],
        rows: [],
        total: 0,
        queryParams: {
          filter: {},
          sort: "-id",
          page: 1,
          limit: 20
        }
      }
    };
  },
  created() {
    this.getRows();
  },
  methods: {
    filter() {
      this.datatable.queryParams.page = 1;
      this.getRows();
    },
    filterClear() {
      this.datatable.queryParams.filter = {};
      this.getRows();
    },
    onPageChange(params) {
      this.datatable.queryParams.page = params.currentPage;
      this.getRows();
    },
    onPerPageChange(params) {
      this.datatable.queryParams.limit = params.currentPerPage;
      this.datatable.queryParams.page = 1;
      this.getRows();
    },
    onSortChange(params) {
      const sortType = params[0].type === "desc" ? "-" : "";
      this.datatable.queryParams.sort = sortType + params[0].field;
      this.getRows();
    },
    async getRows() {
      this.datatable.showTable = true;
      this.datatable.isLoading = true;

      const config = {
        params: {
          ...this.datatable.queryParams
        },
        paramsSerializer: (params) => qs.stringify(params, { encode: false })
      };
      try {
        const res = await UPassService.getPurchases(config);
        const rows = res.data?.data || res.data || [];
        this.datatable.rows = rows.map(r => ({
          ...r,
          student_number: r.student?.number || r.student_number || 'N/A',
          student_name: r.student ? `${r.student.name || ''} ${r.student.surname || ''}` : (r.student_name || 'N/A'),
          semester_name: r.semester?.name || r.semester_name || 'N/A'
        }));
        this.datatable.total = res.data?.pagination?.total || this.datatable.rows.length;
      } catch (error) {
             this.showErrors(error,null)
        } finally {
        this.datatable.isLoading = false;
      }
    },
      async excelExport(){
         try {
             const config = {
                 params: {
                     ...this.datatable.queryParams
                 },
                 paramsSerializer: (params) => qs.stringify(params, { encode: false })
             };
             const res = await UPassService.excelExport(config);
             this._downloadFile(res, 'U-pass-purchased' + '.xlsx');
         }catch (error) {
             this.showErrors(error,null)
         }
      }
  }
};
</script>
